import React, { useContext, useEffect, useState } from "react";
import HyperLogo from "../../Images/HyperLogo.png";
import styled from "styled-components";
import Clock from "./Clock";
import Player from "./Player";
import Subs from "../Subs/Subs";
import EndHalf from "./EndHalf";
import moment from "moment";
import { Button, ScrollBar } from "../../Theme/Hyper";
import { UserContext } from "../../contexts/UserContext";
import Select from "react-select";
import { ControlContext } from "../../contexts/ControlContext";
import { APIContext } from "../../contexts/APIContext";

const Main = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 0.5em;
  background-color: #202731;
  box-sizing: border-box;
  flex-direction: column;
  position: relative;
`;
const Logo = styled.img`
  height: auto;
  width: 50%;
`;
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 4%;
  width: 90%;
  min-height: 40px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const CurrentGraphic = styled.div`
  margin-top: auto;
  width: 100%;
  height: 167px;
  background-color: #181d25;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 0.5em;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: 12px;
  margin: 0px;
  padding-bottom: 10px;
`;
const Buttons = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const NavButton = styled(Button)`
  margin: 0.5em;
  background-color: ${(props) => (props.selected ? "#0adb93" : "")};
  color: ${(props) => (props.selected ? "#1d1d1d" : "")};
`;

const Profile = styled.div`
  width: 100%;
  height: 35px;
  background-color: #202731;
  z-index: 1000;
  position: -webkit-sticky;
  position: sticky;
  box-shadow: 0px 4px 12px -20px rgb(0 0 0 / 20%),
    0px 8px 20px 2px rgb(0 0 0 / 14%), 0 9px 46px 8px rgb(0 0 0 / 12%);
  display: flex;
  align-items: center;
  border-bottom: 1px solid #030304;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
  padding-bottom: 5px;
  margin-bottom: 10px;
`;

const SelectContainer = styled(Select)`
  min-width: 200px;
  margin-bottom: 0.5em;
  width: 90%;
`;

const GraphicsList = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  max-height: 560px;
  overflow-y: auto;
  width: 100%;
  align-items: center;
`;

const DropdownStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: "#0e1219",
      "&:hover": {
        color: "#db0a41",
      },
    };
  },
  control: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
    borderColor: "#384454",
  }),
  valueContainer: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
    borderColor: "#384454",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition, color: "#fff" };
  },
};

export default function RightSideBar({
  game,
  updateGame,
  previewGraphic,
  graphicInPreview,
  animateGraphic,
  animateOffGraphic,
  updateGraphic,
  teams,
  selectedPlayer,
  players,
  stadiums,
  sky,
  squads,
  countries,
  standings,
  kits,
  clearPreview,
  homeManager,
  awayManager,
  groups,
  group,
}) {
  const { user, signOut } = useContext(UserContext);
  const { engines, selectedEngine, setSelectedEngine } =
    useContext(ControlContext);
  const { getGroup, getFixtures } = useContext(APIContext);
  const [view, setView] = useState(0);
  let period = [...(game?.live_data?.periods || [])].sort(
    (a, b) => b.number - a.number
  )[0];

  let latestGoal =
    game && game.live_data?.home_scorers ? game.live_data?.home_scorers : [];

  latestGoal = latestGoal
    .concat(game.live_data?.away_scorers || [])
    .sort((a, b) => b.time - a.time);
  if (latestGoal.length > 0) {
    latestGoal = latestGoal[0].time;
  }
  let time = moment.duration(latestGoal);
  time =
    time.minutes() +
    time.hours() * 60 +
    ":" +
    time.seconds().toString().padStart(2, "0");

  return (
    <Main>
      {!window.hideHeader && (
        <Profile>
          {user?.username}
          <Button
            style={{ border: "1px solid #fff", marginLeft: "auto" }}
            onClick={() => {
              signOut();
            }}
          >
            Sign Out
          </Button>
        </Profile>
      )}
      {engines?.length > 1 && (
        <SelectContainer
          styles={DropdownStyles}
          setSize={true}
          value={{
            value: selectedEngine,
            label: engines?.find((e) => e.key === selectedEngine)?.name,
          }}
          options={engines.map((item, index) => {
            return {
              value: item.key,
              label: item.name,
            };
          })}
          onChange={(e) => {
            setSelectedEngine(e.value);
          }}
          placeholder="Round"
        />
      )}
      <Logo src={HyperLogo}></Logo>
      <Clock
        game={game}
        teams={teams}
        updateGame={updateGame}
        previewGraphic={previewGraphic}
        animateGraphic={animateGraphic}
        animateOffGraphic={animateOffGraphic}
        updateGraphic={updateGraphic}
        sky={sky}
      />
      <Buttons>
        <NavButton selected={view === 0} onClick={() => setView(0)}>
          MAIN
        </NavButton>
        <NavButton selected={view === 1} onClick={() => setView(1)}>
          SUBS
        </NavButton>
      </Buttons>
      <GraphicsList>
        {selectedPlayer && view === 0 && (
          <Player
            player={selectedPlayer}
            game={game}
            previewGraphic={previewGraphic}
            teams={teams}
            sky={sky}
            countries={countries}
            period={period}
          />
        )}
        {view === 1 &&
          (game.lineup?.home?.filter((p) => p.sub_order).length > 0 ||
            game.lineup?.away?.filter((p) => p.sub_order).length > 0) && (
            <Subs
              sky={sky}
              countries={countries}
              previewGraphic={previewGraphic}
              game={game}
              teams={teams}
              players={players}
              homeSubs={game.lineup?.home?.filter((p) => p.sub_order)}
              awaySubs={game.lineup?.away?.filter((p) => p.sub_order)}
            />
          )}
        {view === 0 && (
          <>
            {!selectedPlayer &&
              period?.kick_off === null &&
              period?.number > 1 && (
                <GraphicButton
                  onClick={() => {
                    previewGraphic("Score", {
                      game: game,
                      type: "FT",
                      group,
                      period,
                    });
                  }}
                >
                  FT Score
                </GraphicButton>
              )}
            {!selectedPlayer && !period?.kick_off && period?.number === 1 && (
              <GraphicButton
                onClick={() => {
                  previewGraphic("MatchID", {
                    game: game,
                    teams: teams,
                    stadiums: stadiums,
                    sky: sky,
                    group,
                  });
                }}
              >
                Match ID
              </GraphicButton>
            )}

            {!selectedPlayer && period?.number === 1 && (
              <GraphicButton
                onClick={() => {
                  previewGraphic("Versus", {
                    game: game,
                    teams: teams,
                    sky: sky,
                    group,
                  });
                }}
              >
                Versus
              </GraphicButton>
            )}

            {!selectedPlayer && period?.kick_off && (
              <GraphicButton
                onClick={() => {
                  previewGraphic("Score", {
                    game: game,
                    teams: teams,
                    group,
                    period,
                  });
                }}
              >
                Score
              </GraphicButton>
            )}

            {!selectedPlayer &&
              !period?.kick_off &&
              (period?.number === 1 ||
                game?.competition?.competition_type === "beach") && (
                <GraphicButton
                  onClick={() => {
                    previewGraphic("Formation", {
                      game: game,
                      teams: teams,
                      players: players,
                      team: game.home_team,
                      squads: game.lineup?.home,
                      formation: game.home_formation,
                      manager: homeManager,
                    });
                  }}
                >
                  Home Roster
                </GraphicButton>
              )}

            {!selectedPlayer &&
              !period?.kick_off &&
              (period?.number === 1 ||
                game?.competition?.competition_type === "beach") && (
                <GraphicButton
                  onClick={() => {
                    previewGraphic("Formation", {
                      game: game,
                      teams: teams,
                      players: players,
                      team: game.away_team,
                      squads: game.lineup?.away,
                      formation: game.away_formation,
                      manager: awayManager,
                    });
                  }}
                >
                  Away Roster
                </GraphicButton>
              )}
          </>
        )}
        {!selectedPlayer && (
          <GraphicButton
            onClick={async () => {
              let fixtures = await getFixtures({
                date: game.date,
              });
              fixtures = [...(fixtures || [])]?.sort((a, b) => {
                let a_date = moment(a.date + " " + a.time);
                let b_date = moment(b.date + " " + b.time);
                // Else go to the 2nd item
                if (a_date < b_date) {
                  return -1;
                } else if (a_date > b_date) {
                  return 1;
                } else {
                  // nothing to split them
                  return 0;
                }
              });

              fixtures = fixtures?.slice(0, 4);
              previewGraphic("Fixtures", {
                fixtures,
                game,
              });
            }}
          >
            Fixtures 1
          </GraphicButton>
        )}
        {!selectedPlayer && (
          <GraphicButton
            onClick={async () => {
              let fixtures = await getFixtures({
                date: game.date,
              });
              fixtures = [...(fixtures || [])]?.sort((a, b) => {
                let a_date = moment(a.date + " " + a.time);
                let b_date = moment(b.date + " " + b.time);

                // Else go to the 2nd item
                if (a_date < b_date) {
                  return -1;
                } else if (a_date > b_date) {
                  return 1;
                } else {
                  // nothing to split them
                  return 0;
                }
              });

              fixtures = fixtures?.slice(4, 8);
              previewGraphic("Fixtures", {
                fixtures,
                game,
              });
            }}
          >
            Fixtures 2
          </GraphicButton>
        )}
        {!selectedPlayer && (
          <GraphicButton
            onClick={async () => {
              let fixtures = await getFixtures({
                date: game.date,
              });
              fixtures = [...(fixtures || [])]?.sort((a, b) => {
                let a_date = moment(a.date + " " + a.time);
                let b_date = moment(b.date + " " + b.time);
                // Else go to the 2nd item
                if (a_date < b_date) {
                  return -1;
                } else if (a_date > b_date) {
                  return 1;
                } else {
                  // nothing to split them
                  return 0;
                }
              });
              fixtures = fixtures?.slice(8, 12);
              previewGraphic("Fixtures", {
                fixtures,
                game,
              });
            }}
          >
            Fixtures 3
          </GraphicButton>
        )}
        {!selectedPlayer && (
          <GraphicButton
            onClick={async () => {
              let fixtures = await getFixtures({
                date: game.date,
              });
              fixtures = [...(fixtures || [])]?.sort((a, b) => {
                let a_date = moment(a.date + " " + a.time);
                let b_date = moment(b.date + " " + b.time);
                // Else go to the 2nd item
                if (a_date < b_date) {
                  return -1;
                } else if (a_date > b_date) {
                  return 1;
                } else {
                  // nothing to split them
                  return 0;
                }
              });
              fixtures = fixtures?.slice(12, 15);
              previewGraphic("Fixtures", {
                fixtures,
                game,
              });
            }}
          >
            Fixtures 4
          </GraphicButton>
        )}
        {!selectedPlayer && (
          <GraphicButton
            onClick={async () => {
              let date = game.date;
              if (
                game?.competition?.name?.toUpperCase()?.indexOf("WOMEN") === -1
              ) {
                date = "2023-11-04Z";
              }
              let fixtures = await getFixtures({
                date: date,
              });

              fixtures = fixtures?.filter(
                (g) => g.competition?.name === game?.competition?.name
              );

              previewGraphic("Bracket", {
                fixtures,
                game,
              });
            }}
          >
            Bracket
          </GraphicButton>
        )}

        {!selectedPlayer &&
          groups?.length > 0 &&
          groups?.map((g) => {
            return (
              <GraphicButton
                onClick={async () => {
                  let new_group = await getGroup(g?._id);

                  previewGraphic("Group Table", {
                    game: game,
                    teams: teams,
                    players: players,
                    team: game.away_team,
                    squads: game.lineup?.away,
                    formation: game.away_formation,
                    manager: awayManager,
                    group: new_group,
                  });
                }}
              >
                {g?.title}
              </GraphicButton>
            );
          })}
      </GraphicsList>
      {graphicInPreview && (
        <CurrentGraphic
          style={{ bottom: window.hideHeader === true ? "40px" : "10px" }}
        >
          {graphicInPreview.name}
          <GraphicButton
            style={{ height: "40px", backgroundColor: "#383f4a" }}
            onClick={() => {
              clearPreview(graphicInPreview.name);
            }}
          >
            CLEAR PVW (CTRL + Q)
          </GraphicButton>

          <GraphicButton
            green
            style={{ height: "40px" }}
            onClick={() => {
              animateGraphic(graphicInPreview.name);
            }}
          >
            IN (F8) or (-)
          </GraphicButton>
          <GraphicButton
            red
            style={{ height: "40px" }}
            onClick={() => {
              animateOffGraphic(graphicInPreview.name);
            }}
          >
            OUT (F9) or (*)
          </GraphicButton>
        </CurrentGraphic>
      )}
    </Main>
  );
}
